import dayjs from 'dayjs'
import AppHeader from '../AppHeader'
import EsMyCardSubMenu from '../EsMyCardSubMenu'
let utils = require('../../utils')
import $ from 'jquery'
global.jQuery = $
window.jQuery = $

export default {
  name: 'es-mycard-favorite-list',
  components: {
    AppHeader,
    EsMyCardSubMenu
  },
  created: function () {
    if (window.sessionStorage.getItem('mycard_favorite_list_scroll_top')) {
      const data = JSON.parse(window.sessionStorage.getItem('mycard_favorite_list_scroll_top'))
      this.currentPage = data.currentPage
      this.search('backPageLoad')
    } else {
      this.search('firstLoad')
    }
    // 最下部スクロール検索イベント
    utils.scrollBottomSearchEvent(this.search, 'addLoad', 'button.next-page-search-btn')
  },
  filters: {
    formatDate (date) {
      return dayjs(date).format('YYYY/MM/DD HH:mm')
    }
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll)
  },
  updated () {
    if (window.sessionStorage.getItem('mycard_favorite_list_scroll_top') && this.searchEnd === true) {
      const data = JSON.parse(window.sessionStorage.getItem('mycard_favorite_list_scroll_top'))
      if (data['path'] === this.$router.history.current.path) {
        $(window).scrollTop(data['scrollTop'])
        // 自動スクロール後の手動スクロールイベントの発生でセッションからスクロール情報を削除する。そのためのフラグ。
        this.isScrollDoneFlag = true
      }
    }
  },
  data: () => ({
    cardList: [],
    showHamburgerList: [],
    deleteTarget: null,
    deleteTargetIndex: null,
    showDeleteCardCompleteModal: false,
    searchEnd: false,
    nextExist: false,
    currentPage: 0,
    isScrollDoneFlag: false,
    isReportProblemModal: false,
    reportTargetIndex: null,
    isProblemReported: false,
    isLikePushing: false
  }),
  /** 画面遷移時 */
  beforeRouteLeave (to, from, next) {
    utils.scrollBottomSearchEventRemove() // 最下部スクロール検索イベント削除
    const $win = $(window)
    $win.on('load scroll', function () {
      $('.es-mycard-favorite-list').css('margin-top', 0)
    })
    if (to.name === 'EsMyCardDetail' || to.name === 'EsMyCardLikeList') {
      const savedata = {
        'path': this.$router.history.current.path,
        'scrollTop': $(window).scrollTop(),
        'currentPage': this.currentPage
      }
      window.sessionStorage.setItem('mycard_favorite_list_scroll_top', JSON.stringify(savedata))
    } else {
      window.sessionStorage.removeItem('mycard_favorite_list_scroll_top')
    }
    next()
  },
  computed: {
    getBackgroundImageByImageName () {
      return imageName => {
        return require(`../../../static/mycard/background/${imageName}.png`)
      }
    },
    getCharacter1ImageByImageName () {
      return (pathName, imageName) => {
        return require(`../../../static/mycard/character1/${pathName}/${imageName}.png`)
      }
    },
    getUserImage () {
      return imagePath => {
        if (imagePath) {
          return `${imagePath}?token=${localStorage.access_token}&timestamp=${this.timeStamp}`
        }
        return require('../images/icon_submenu_face.png')
      }
    },
    getFrontImageByPath () {
      return imagePath => {
        return `${imagePath}` + '?token=' + localStorage.access_token + '&timestamp=' + this.timeStamp
      }
    },
    getLikeImageByState () {
      return state => {
        if (state) {
          return require('../images/icon_heart_pink.png')
        }
        return require('../images/icon_heart_blank.png')
      }
    },
    getFavoriteImageByState () {
      return state => {
        if (state) {
          return require('../images/icon_star_yellow.png')
        }
        return require('../images/icon_star_blank.png')
      }
    },
    timeStamp () {
      var d = new Date()
      var year = d.getFullYear()
      var month = d.getMonth() + 1
      var day = d.getDate()
      var hour = (d.getHours() < 10) ? '0' + d.getHours() : d.getHours()
      var min = (d.getMinutes() < 10) ? '0' + d.getMinutes() : d.getMinutes()
      var sec = (d.getSeconds() < 10) ? '0' + d.getSeconds() : d.getSeconds()
      return year + '' + month + '' + day + '' + hour + '' + min + '' + sec
    }
  },
  methods: {
    goEsMycardDetail: function (id) {
      window.sessionStorage.setItem('es_mycard_detail_referrer', this.$router.history.current.path)
      this.$router.push({ path: `/es_mycard/${id}/detail`})
    },
    goEsMycardLikeList: function (cardId) {
      window.sessionStorage.setItem('es_mycard_like_list_referrer', this.$router.history.current.path)
      this.$router.push({ path: `/like_list/${cardId}` })
    },
    // actions
    async search (readMore) {
      let data = {}

      if (readMore == 'addLoad') {
        this.currentPage += 1
        data['current_page'] = this.currentPage
        data['add_search'] = true
      } else {
        if (readMore == 'firstLoad') {
          this.currentPage = 0
        } else {
          this.currentPage += 1
          data['current_page'] = this.currentPage
          data['back_page_search'] = true
        }
        this.searchEnd = false
      }

      let res = await this.$store.dispatch('GET_MYCARD_FAVORITE_LIST', { data: data })
      .catch(err => {
        console.log(err)
        return
      })
      if (readMore == 'addLoad') {
        this.cardList = this.cardList.concat(res.cards)
      } else {
        this.cardList = res.cards
        this.searchEnd = true
      }
      this.nextExist = res.next_exist
      this.createshowHamburgerList()
    },
    createshowHamburgerList () {
      this.cardList.forEach(_ => {
        this.showHamburgerList.push(false)
      })
    },
    async sendLike (index, cardId) {
      if (!this.isLikePushing) {
        this.isLikePushing = true
        const currentData = this.cardList[index]
        currentData.you_liked = !currentData.you_liked
        let data = {
          card_id: cardId
        }
        let res = await this.$store.dispatch('CARD_LIKE_UPDATE', { data: data })
        .catch(err => {
          console.log(err)
          return
        })
        if (res.success === 'delete') {
          currentData.like -= 1
        } else {
          currentData.like += 1
        }
        this.cardList.splice(index, 1, currentData)
        this.isLikePushing = false
      }
    },
    async sendFavorite (index, cardId) {
      const currentData = this.cardList[index]
      currentData.you_favorited = !currentData.you_favorited
      this.cardList.splice(index, 1, currentData)
      let data = {
        card_id: cardId
      }
      await this.$store.dispatch('CARD_FAVORITE_UPDATE', { data: data })
      .catch(err => {
        console.log(err)
        return
      })
    },
    showDeleteCardModal (id, cardIndex) {
      this.deleteTarget = id
      this.deleteTargetIndex = cardIndex
      this.toggleHamburger(cardIndex)
    },
    async deleteCardByTargetId () {
      let data = {
        card_id: this.deleteTarget
      }
      await this.$store.dispatch('CARD_DELETE', { data: data })
      .catch(err => {
        console.log(err)
        return
      })
      this.cardList.splice(this.deleteTargetIndex, 1)
      this.showHamburgerList.splice(this.deleteTargetIndex, 1)
      this.deleteTarget = null
      this.showDeleteCardCompleteModal = true
    },
    toggleHamburger (index) {
      // ハンバーガーメニュー初期化
      for (let listIndex = 0; listIndex < this.showHamburgerList.length; listIndex++) {
        if (index !== listIndex) {
          this.showHamburgerList[listIndex] = false
        }
      }
      const currentState = this.showHamburgerList[index]
      this.showHamburgerList.splice(index, 1, !currentState)
    },
    authorityCheck: function (shopId) {
      if (localStorage.user_authority == 1) {
        return true
      }
      if (localStorage.user_authority <= 2 && shopId == localStorage.shop_id) {
        return true
      }
      return false
    },
    handleScroll () {
      if (this.isScrollDoneFlag) {
        window.sessionStorage.removeItem('mycard_favorite_list_scroll_top')
        this.isScrollDoneFlag = false
      }
    },
    rmEmoji: function(text) {
      this.cardList[this.reportTargetIndex].problem_report_reason = utils.removeEmoji(text)
    },
    cancelReportProblem: function() {
      // 問題報告キャンセル処理
      this.isReportProblemModal = false
      this.cardList[this.reportTargetIndex].problem_report_reason = ''
    },
    showReportProblem (cardIndex) {
      // 問題報告モーダル表示
      this.isReportProblemModal = true
      this.toggleHamburger(cardIndex)
      this.reportTargetIndex = cardIndex
    },
    async reportProblem () {
      // ボタン連打時に複数報告されないように制御
      if (this.isProblemReported) return
      this.isProblemReported = true
      // 問題報告処理
      const data = {
        id: this.cardList[this.reportTargetIndex].id,
        problem_report_user_id: localStorage.user_id,
        problem_report_reason: this.cardList[this.reportTargetIndex].problem_report_reason,
        url: process.env.ASOVI_URL + `/#/es_mycard/${this.cardList[this.reportTargetIndex].id}/detail`
      }
      await this.$store.dispatch('PROBLEM_REPORT_UPDATE', data)
      .catch(err => {
        console.error(err)
        return
      })
      this.isReportProblemModal = false
      this.cardList[this.reportTargetIndex].is_problem_reported = 1
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/es-mycard-favorite-list.js